import React, { useState } from 'react';
import MarketingConsent from '../components/MarketingConsent';
import './PrivateEvents.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import event1 from '../assets/events/747A3806.jpg';
import event2 from '../assets/events/747A3765.jpg';
import event3 from '../assets/events/747A3755.jpg';
import event4 from '../assets/events/747A3743.jpg';
import event5 from '../assets/events/747A3733.jpg';
import event6 from '../assets/events/747A3634.jpg';

const eventGalleryImages = [
  {
    src: event1,
    alt: 'Cozy lounge seating set for a private gathering'
  },
  {
    src: event2,
    alt: 'Guests enjoying cocktails during an evening celebration'
  },
  {
    src: event3,
    alt: 'Intimate dining setup with warm lighting'
  },
  {
    src: event4,
    alt: 'Server preparing the bar for a toast'
  },
  {
    src: event5,
    alt: 'Friends gathered around the bar during a party'
  },
  {
    src: event6,
    alt: 'Expansive view of the Highlands event space'
  }
];

const PrivateEvents = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    date: '',
    time: '',
    peopleCount: '',
    eventType: '',
    additionalDetails: '',
    marketingConsent: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const subject = encodeURIComponent('Private Event Request');
    const body = encodeURIComponent(`
Full Name: ${formData.fullName}
Email: ${formData.email}
Phone Number: ${formData.phoneNumber}
Date and Time: ${formData.date} ${formData.time}
Number of People: ${formData.peopleCount}
Event Type: ${formData.eventType}
Additional Details: ${formData.additionalDetails}
Email Marketing Opt-In: ${formData.marketingConsent ? 'Yes' : 'No'}
    `);
    
    window.open(`mailto:highlandssportsbar@gmail.com?subject=${subject}&body=${body}`, '_blank');
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="private-events-container">
      <div className="private-events-header">
        <h1 className="title">Private Events</h1>
        <p className="subtitle">Host your next special occasion with us</p>
      </div>

      <section
        className="private-events-gallery"
        aria-label="Recent Highlands private events photo gallery"
      >
        <div className="private-events-gallery__intro">
          <p className="gallery-eyebrow">@events</p>
          <h2>See the space come alive</h2>
          <p>
            From corporate happy hours to milestone celebrations, our flexible
            layout, full bar, and dedicated team make it easy to create a
            memorable night for every guest.
          </p>
        </div>
        <div className="private-events-carousel">
          <Slider {...{
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                }
              }
            ]
          }}>
            {eventGalleryImages.map((image, index) => (
              <div key={index} className="carousel-slide">
                <figure className="gallery-item">
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    decoding="async"
                  />
                </figure>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      
      <form onSubmit={handleSubmit} className="private-events-form">
        <div className="form-group">
          <label htmlFor="fullName">Full Name<span className="required">*</span></label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Your full name"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email<span className="required">*</span></label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your email address"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number<span className="required">*</span></label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="(555) 555-5555"
            required
          />
        </div>

        <div className="form-group date-time-group">
          <label>Event Date and Time<span className="required">*</span></label>
          <div className="date-time-inputs">
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="peopleCount">Expected Number of Guests<span className="required">*</span></label>
          <select
            id="peopleCount"
            name="peopleCount"
            value={formData.peopleCount}
            onChange={handleChange}
            required
          >
            <option value="">Select a range</option>
            <option value="1-20">1-20 guests</option>
            <option value="21-40">21-40 guests</option>
            <option value="41-60">41-60 guests</option>
            <option value="61-80">61-80 guests</option>
            <option value="81-100">81-100 guests</option>
            <option value="100+">100+ guests</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="eventType">Type of Event<span className="required">*</span></label>
          <select
            id="eventType"
            name="eventType"
            value={formData.eventType}
            onChange={handleChange}
            required
          >
            <option value="">Select event type</option>
            <option value="Birthday">Birthday Party</option>
            <option value="Corporate">Corporate Event</option>
            <option value="Wedding">Wedding Reception</option>
            <option value="Holiday">Holiday Party</option>
            <option value="Reunion">Reunion</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="additionalDetails">Additional Details or Special Requests</label>
          <textarea
            id="additionalDetails"
            name="additionalDetails"
            value={formData.additionalDetails}
            onChange={handleChange}
            placeholder="Tell us more about your event, including any special requirements or questions you may have."
            rows="4"
          />
        </div>

        <MarketingConsent
          checked={formData.marketingConsent}
          onChange={handleChange}
        />

        <button type="submit" className="submit-button">
          Submit Event Request
        </button>
      </form>
    </div>
  );
};

export default PrivateEvents; 